<template>
  <!-- D: 얼럿은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <!-- CYB_PC_OD_01_04 -->
  <div id="CYB_PC_OD_01_04" class="alert" data-alert>
    <div class="dialog type-large">
      <div class="dialog-content">
        <div class="text-wrap">
          <p class="text">취소 신청 사유를 입력해주세요</p>
          <div class="c-textarea-area type-small">
            <label for="user-message" class="sr-only"
              >취소신청사유 신청란</label
            >
            <textarea
              id="user-message"
              required
              aria-required="true"
              aria-describedby="message-help"
            >
안녕하십니까? 질문이 있습니다. 질문은 다음과 같습니다.</textarea
            >
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="c-btn-area">
          <button
            type="button"
            class="c-button type-secondary"
            data-alert-close
          >
            <span>취소</span>
          </button>
          <button type="button" class="c-button type-primary" data-alert-close>
            <span>확인</span>
          </button>
        </div>
      </div>
    </div>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>
<script setup name="cancelFieldPop"></script>
